import { BuildInfo, generateBuildInfoDev } from '@naturalcycles/js-lib'
import bi from '../../environments/buildInfo.json'

export let buildInfo = bi as any as BuildInfo

if (buildInfo.dev) buildInfo = generateBuildInfoDev() as any
